import { fetchApi } from "@/lib/api/index.ts";

interface LowEngagementTeen {
  teenId: string;
  sdkUrl: string;
  teenName: string;
  uniqueMessageDays: number;
}

interface LowEngagementResponse {
  lowEngagementTeens: LowEngagementTeen[];
}

export const getLowEngagementTeens = async (): Promise<LowEngagementTeen[]> => {
  const response = await fetchApi<LowEngagementResponse>({
    url: "/v2/mentor/low-engagement-teens",
    method: "GET",
  });

  if (!response.data) {
    throw new Error("No data returned from API");
  }

  return response.data.lowEngagementTeens;
};
